import { colors } from '../../colors';
var location = {
  bgColor: colors.white,
  cardBgColor: colors.white,
  secondaryBgColor: colors.lightPink,
  cardShadow: colors.black
};
export default location;